//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
/**@type {import('../types').DataType<import('./types').ContactActivityDataModel>} */

var CONTACT_DATA_TYPE = {
  data: {
    url: '/backend/contactactivity',
    itemUrl: '/backend/contactactivity?id={id}',
    // deleteItemUrl: '/backend/contactactivity?id={id}',
    dataKey: 'contactActivities',
    idKeyProp: 'Id',
    onBeforeRequest: function onBeforeRequest(props, request) {
      if (request.type === 'loadView' && props.dataProps) {
        return {
          query: {
            contactId: props.dataProps.contactId
          }
        };
      }
    }
  },
  placeholders: {
    type: function type() {
      return 'activity';
    },
    label: function label() {
      return 'activity';
    },
    icon: function icon() {
      return 'activity';
    }
  },
  columns: [{
    id: 'DateTime',
    children: 'Date',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.DateTime, {
        value: data.DateTime
      });
    }
  }, {
    id: 'Communication',
    children: 'Communication',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return data.Communication ? React.createElement(Formatter.DataLink, {
        dataType: "project",
        id: data.Communication.Id
      }) : React.createElement(Formatter.MissingValue, null);
    }
  }, {
    id: 'Journey',
    children: 'Journey',
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return data.Journey ? React.createElement(Formatter.DataLink, {
        dataType: "journey",
        id: data.Journey.Id
      }) : React.createElement(Formatter.MissingValue, null);
    }
  }, {
    id: 'Email',
    children: 'Email',
    formatter: function formatter(_ref4) {
      var data = _ref4.data;
      return data.Ticket ? React.createElement(Formatter.DataLink, {
        dataType: "jobTicket",
        id: data.Ticket.Id
      }) : React.createElement(Formatter.MissingValue, null);
    }
  }],
  contextMenu: []
};
export default CONTACT_DATA_TYPE;